import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class ActivityService {
    static getOpenActivities(entityId, entityType) {
        return BaseService.get(`activities-opened?entityId=${entityId}&entityType=${entityType}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.activity.createdOn = parseDate(x.activity.createdOn);
                x.activity.updatedOn = parseDate(x.activity.updatedOn);
            });
            return w;
        }));
    }
    static getActivities(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`activities?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.activity.createdOn = parseDate(x.activity.createdOn);
                x.activity.updatedOn = parseDate(x.activity.updatedOn);
            });
            return w;
        }));
    }
    static fetchActivity(oid, type) {
        return BaseService.get(`activities/${oid}/${type}`).pipe(map(x => {
            x.payload.activity.createdOn = parseDate(x.payload.activity.createdOn);
            x.payload.activity.updatedOn = parseDate(x.payload.activity.updatedOn);
            return x;
        }));
    }
    static saveActivity(dto) {
        return BaseService.save(`activities`, dto);
    }
    static completeActivity(oid) {
        let dto = {
            oid: oid
        };
        return BaseService.save(`activities-complete`, dto);
    }
    static deleteActivity(oid) {
        return BaseService.delete(`activities/${oid}`);
    }
}
